import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useContext } from 'react';
import { createContext } from 'react';
import qs from 'qs';
import { createBrowserHistory } from 'history';
import crypto from 'crypto';

export const LanguageContext = createContext({});

export const history = createBrowserHistory();

export const getQueryParams = () =>
  qs.parse(history.location.search, { ignoreQueryPrefix: true, delimiter: '&' });

export const updateQueryParam = (param, value) => {
  const params = getQueryParams();
  params[param] = value;
  const newQstring = qs.stringify(params, { delimiter: '&' });
  history.push({
    pathname: history.location.pathname,
    search: `?${newQstring}`
  });
};

export const removeQueryParam = param => {
  const params = getQueryParams();
  params[param] = undefined;
  const newQstring = qs.stringify(params, { delimiter: '&' });
  history.push({
    pathname: history.location.pathname,
    search: `?${newQstring}`
  });
};



const hostname = window.location.hostname;
const cookieDomain = hostname.indexOf('localhost') !== -1 ? 'localhost' : 'creditinfo.is';

const setCookie = lang => {
  Cookies.set('userCulture', 'c=is-IS|uic=' + lang, {
    expires: 365,
    path: '/',
    domain: cookieDomain
  });
};

const swapLangQueryParam = lang => {
  const searchParams = getQueryParams();
  if (searchParams.lang) {
    updateQueryParam('lang', lang);
  }
};

let storedLang = 'is';
let langCookie = Cookies.get('userCulture', { domain: cookieDomain });
const { lang } = getQueryParams();

if (!lang && langCookie !== undefined) {
  var idx = langCookie.indexOf('uic=');
  if (idx !== -1) {
    storedLang = langCookie.substr(idx + 4, 2);
  } else {
    idx = langCookie.indexOf('uic%3D');
    if (idx !== -1) {
      storedLang = langCookie.substr(idx + 6, 2);
    }
  }
} else {
  storedLang = lang || storedLang;
  setCookie(storedLang);
}



export const LanguageProvider = ({ locale = undefined, children, lang = storedLang }) => {
  const [showKey, setShowKey] = useState(false);
  const [language, setLanguage] = useState(lang);
  const [localeObj, setLocaleObj] = useState(locale);
  const [translationDB, setTranslationDB] = useState();

  function updateLanguage(lang) {
    setLanguage(lang);
    setCookie(lang);
    swapLangQueryParam(lang);
  }

  function updateLocaleObj(lang, newLocaleObj) {
    if (locale !== undefined) {
      throw new Error(
        'LanguageProvider is being controlled via the locale prop. ' +
          'updateLocaleForLang should only be used if the component is uncontrolled.'
      );
    } else {
     //console.log("updateLocalObj", lang, newLocaleObj);
      setLocaleObj(old => ({
        ...old,
        [lang]: newLocaleObj
      }));
    }
  }

  useEffect(() => {
    if (history.location.search.includes('show_locale_string')) {
      setShowKey(true);
    }

    let languages = [];
    languages.push(['is',{}]);
    languages.push(['en',{}]);
    //Init the default languages
    setTranslationDB(languages);
    
  }, []);

  let currentLocale = localeObj;
  // Check if locale is controlled from the outside.
  if (locale !== undefined) {
    currentLocale = locale;
  }


  function t(str, ...args) {
    if (showKey) return str;
    if (!str) return '';

    let notFoundInImported = false;
    
    if (!currentLocale || Object.keys(currentLocale).length === 0 || !currentLocale[lang]) {            
      notFoundInImported = true;
    }

    if (!notFoundInImported)
    {
      let s = currentLocale[language][str];
      if (!s){
        notFoundInImported = true;
      }
      else{
        if (args.length === 0) return s;
        if (s) {
          for (let i = 0; i < args.length; i++) {
            let index = '{' + i + '}';
            s = s.replace(index, args[i]);
          }
        }
        return s;
      }
    }

    if (notFoundInImported){      
      if (!translationDB){
        return str;
      }
      let strHash = crypto.createHash('sha256').update(str).digest('hex');
      //console.log("status trans", str, translationDB, strHash);      
      return str;
      //TODO finish later.
      // let s = translationDB[language][strHash];
      // if (!s){
      //   translationDB[language][strHash] = str;
      //   return str;
      // }
      // return s;      
    }
    
  }


  // function t(str, ...args) {
  //   if (showKey) return str;
  //   if (!str) return '';

  //   if (!currentLocale || Object.keys(currentLocale).length === 0 || !currentLocale[lang]) {
  //     return '';
  //   }

  //   const hashCode = hashStr => -hashStr.split('').reduce((a,b) => (((a << 5) - a) + b.charCodeAt(0))|0, 0);
  
  // //   // test
  // // console.log("Hash code",hashCode('Hello!'))
  // // console.log("Hash code",hashCode('Ég er hér að prófa að sýna einhver skilgriening hér er allt með allt sem þér.'))

  //   let s = currentLocale[language][str];
  //   if (args.length === 0) return s;
  //   if (s) {
  //     for (let i = 0; i < args.length; i++) {
  //       let index = '{' + i + '}';
  //       s = s.replace(index, args[i]);
  //     }
  //   }
  //   return s;
  // }

  return (
    <LanguageContext.Provider
      value={{
        lang: language,
        t: t,
        setLanguage: updateLanguage,
        updateLocaleForLang: updateLocaleObj,
        locale: currentLocale,
        localeLoaded: currentLocale !== undefined
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;

export class BackwardsCompatLanguageProvider extends React.Component {
  static childContextTypes = {
    locale: PropTypes.object
  };

  getChildContext() {
    const { locale, lang } = this.props;
    return {
      locale: {
        ...locale[lang],
        currentLang: lang
      }
    };
  }

  render() {
    return this.props.children;
  }
}

export function useLocale() {
  const { lang, t, setLanguage, updateLocaleForLang, locale } = useContext(LanguageContext);
  return { lang, t, setLanguage, updateLocaleForLang, locale };
}

